import { css, injectGlobal } from 'styled-components'

export const sizes = {
  xl: 2500,
	giant: 2100,
	l: 1600,
	mid: 1420,
  desktop: 1200,
  tablet: 840,
	mobile: 600,
	xs: 360
}

export const maxHeight = Object.keys(sizes).reduce((accumulator, label) => {
  accumulator[label] = (...args) => css`
    @media (max-height: ${sizes[label]}px) {
      ${css(...args)};
    }
  `
  return accumulator
}, {})

export const above = Object.keys(sizes).reduce((accumulator, label) => {
  accumulator[label] = (...args) => css`
    @media (min-width: ${sizes[label]}px) {
      ${css(...args)};
    }
  `
  return accumulator
}, {})

export const below = Object.keys(sizes).reduce((accumulator, label) => {
  accumulator[label] = (...args) => css`
    @media (max-width: ${sizes[label]}px) {
      ${css(...args)};
    }
  `
  return accumulator
}, {})

export function clearFix() {
  return `
    &:after {
      display: table;
      content: "";
      clear: both;
    }
  `;
}

export function fontFace(name, src, fontWeight = 'normal', fontStyle = 'normal'){

	return `
			@font-face{
					font-family: "${name}";
					src: url(${require('../../public/fonts/' + src + '.woff2')}?#iefix) format("woff2"),
							 url(${require('../../public/fonts/' + src + '.woff')}) format("woff"),
							 url(${require('../../public/fonts/' + src + '.ttf')}) format("truetype");
					font-style: ${fontStyle};
					font-weight: ${fontWeight};
			}
	`
}


// WEBPACK FOOTER //
// ./src/style/functions.js